import { Collapse, Stack, Typography } from "@mui/material";
import { ReadOnlyQuill } from "@/components/common/quill/readOnlyQuill";
import { TEXT_PRIMARY_DARK } from "@/config/mui/colorPalette";
import { formattedPrice } from "@/utils";

type PackageCardInfoSectionProps = {
  title: string;
  unitPrice: number;
  description: string;
  isFocused: boolean;
  isMobile: boolean;
};

export default function PackageCardInfoSection({
  title,
  unitPrice,
  description,
  isFocused,
  isMobile,
}: PackageCardInfoSectionProps) {
  return (
    <Stack
      sx={{
        gap: 0.5,
      }}
    >
      <Typography
        variant="subtitleDefault"
        noWrap={!isFocused}
        sx={{
          color: TEXT_PRIMARY_DARK,
        }}
      >
        {title}
      </Typography>
      <Typography
        variant={isMobile ? "labelDefault" : "labelSmall"}
        sx={{
          color: TEXT_PRIMARY_DARK,
        }}
      >
        {formattedPrice(unitPrice)}
      </Typography>
      <Collapse in={isFocused}>
        <ReadOnlyQuill value={description} />
      </Collapse>
    </Stack>
  );
}
